import { Component } from "react";

/**
 * Top-level error boundary so any unexpected render error doesn't
 * blank the page or trigger the CRA red error overlay.
 */
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, message: "" };
  }

  static getDerivedStateFromError(err) {
    return { hasError: true, message: err?.message || "Algo falló" };
  }

  componentDidCatch(err, info) {
    // Swallow — keep app alive
    // eslint-disable-next-line no-console
    console.warn("[ErrorBoundary]", err, info);
  }

  handleReload = () => {
    this.setState({ hasError: false, message: "" });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center px-6 bg-deck-bg text-white">
          <div className="max-w-sm text-center glass-card rounded-3xl p-8">
            <div className="w-16 h-16 rounded-2xl bg-[#EF4444] mx-auto mb-4 flex items-center justify-center text-3xl">
              !
            </div>
            <h1 className="text-2xl font-heading font-black mb-2">
              Algo salió mal
            </h1>
            <p className="text-sm font-mono text-white/60 mb-6">
              {this.state.message}
            </p>
            <button
              onClick={this.handleReload}
              data-testid="error-reload-btn"
              className="w-full bg-[#2563EB] hover:bg-[#1D4ED8] text-white font-heading font-bold rounded-xl py-3"
            >
              Recargar
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
